// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1e55fd64","58":"7817afdc","237":"2570b591","245":"ccc28470","453":"b7370cb2","459":"7d9687af","490":"8c13a4ae","733":"f9e31c3b","776":"1f84adf7","778":"ceac91fa","788":"d6749a1c","855":"bbdd22da","962":"b07ce81e"}[chunkId] + ".chunk.js";
};